import { render, staticRenderFns } from "./projectManger.vue?vue&type=template&id=2a5d7019&scoped=true&"
import script from "./projectManger.vue?vue&type=script&lang=js&"
export * from "./projectManger.vue?vue&type=script&lang=js&"
import style0 from "./projectManger.vue?vue&type=style&index=0&id=2a5d7019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d7019",
  null
  
)

export default component.exports